import AccordionItemHandler from 'components/forms/new/AccordionItemHandler';
import { Box } from '@chakra-ui/react';
import ItemInvoiceToggle from '../formFields/ItemInvoiceToggle';
import InvoiceExportToggles from '../formFields/InvoiceExportToggles';
import BillingNoteTable from 'pages/organisations/sharedComponents/BillingNoteTable';
import { getBillingFieldPaths } from '../../constants';
import { useCompanyForm } from '../../hooks/useCompanyForm';

const BillingInvoiceExport = ({
    errors,
    touched,
    darkMode,
    organisationMode,
}) => {
    // const to determine the billingState for use in queries
    const {
        updateFormData,
        formData,
        deletedBillingNoteIDs,
        setDeletedBillingNoteIDs,
    } = useCompanyForm();

    const setBillingState = (payload) => {
        updateFormData(
            getBillingFieldPaths(organisationMode).BILLING_NOTES,
            payload.billingNotes,
        );
    };

    const formFields = () => {
        const fields = [
            <ItemInvoiceToggle key="itemInvoiceToggle" darkMode={darkMode} />,
            <InvoiceExportToggles
                key="invoiceExportToggles"
                organisationMode={organisationMode}
            />,
            <Box key="billingNoteTable" paddingTop="20px">
                <BillingNoteTable
                    setBillingState={setBillingState}
                    formData={formData}
                    mode={organisationMode}
                    updateFormData={updateFormData}
                    deletedBillingNoteIDs={deletedBillingNoteIDs}
                    setDeletedBillingNoteIDs={setDeletedBillingNoteIDs}
                />
            </Box>,
        ];

        return fields;
    };
    return (
        <AccordionItemHandler
            index={0}
            key="companyBillingInvoiceExport"
            label="Invoice Export"
            errors={errors}
            touched={touched}
            defaultIsOpen={true}>
            {formFields()}
        </AccordionItemHandler>
    );
};

export default BillingInvoiceExport;
